/* Erafav 1.0 storefront behaviour. No dependencies. */
(function () {
  'use strict';

  var T = window.theme || { routes: {} };
  var doc = document;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var n = (cents || 0) / 100;
    var fmt = T.moneyFormat || '${{amount}}';
    var group = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') { return group(String(Math.round(n)), ','); }
      if (key === 'amount_with_comma_separator') { var p = n.toFixed(2).split('.'); return group(p[0], '.') + ',' + p[1]; }
      if (key === 'amount_no_decimals_with_comma_separator') { return group(String(Math.round(n)), '.'); }
      var q = n.toFixed(2).split('.'); return group(q[0], ',') + '.' + q[1];
    }).replace(/<[^>]*>/g, '');
  }
  var CURRENCY = money(0).replace(/[\d.,\s]/g, '') || '$';
  /* $1,039.99 -> dollars large, cents raised (matches snippets/price.liquid) */
  function priceHTML(cents) {
    var s = money(cents);
    var m = /^([^0-9]*)([0-9][0-9,]*)(?:[.,]([0-9]{2}))?(.*)$/.exec(s);
    if (!m) { return esc(s); }
    return '<span class="visually-hidden">' + esc(s) + '</span><span class="price__split" aria-hidden="true"><span class="price__sym">' + esc(m[1] || '$') + '</span><span class="price__int">' + esc(m[2]) + '</span><span class="price__dec">' + esc(m[3] || '00') + '</span></span>';
  }
  function sized(url, w) { if (!url) { return ''; } return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function loadImg(img) { if (img.dataset && img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); } }
  var ICON = {
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    left: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14.5 6-6 6 6 6"/></svg>',
    right: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9.5 6 6 6-6 6"/></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg>',
    chev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="icon"><path d="m6.5 9.5 5.5 5.5 5.5-5.5"/></svg>',
    x: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" class="icon"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    doc: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 3.5h7l4 4v13H7z"/><path d="M14 3.5v4h4"/></svg>',
    grid: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/></svg>'
  };

  /* ------------------------------------------------------------ scroll lock */
  var locks = 0;
  function lock() {
    if (locks++ === 0) {
      var sw = window.innerWidth - doc.documentElement.clientWidth;
      if (sw > 0) { doc.body.style.paddingRight = sw + 'px'; }
      doc.body.classList.add('is-locked');
    }
  }
  function unlock() {
    locks = Math.max(0, locks - 1);
    if (locks === 0) { doc.body.classList.remove('is-locked'); doc.body.style.paddingRight = ''; }
  }
  function focusables(root) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
  }
  function trap(root, e) {
    var f = focusables(root);
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (doc.activeElement === first || !root.contains(doc.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ------------------------------------------------------------ toast */
  var toastTimer;
  function toast(html, type) {
    var el = $('[data-toast]');
    if (!el) { return; }
    el.innerHTML = html;
    el.className = 'toast' + (type ? ' toast--' + type : '');
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 400);
    }, 2800);
  }

  /* ------------------------------------------------------------ drawers */
  var Drawer = {
    current: null,
    opener: null,
    open: function (id, opener) {
      var d = doc.getElementById(id);
      if (!d) { return; }
      if (this.current && this.current !== d) { this.close(true); }
      if (this.current === d) { return; }
      closeNav();
      this.current = d;
      this.opener = opener || doc.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      lock();
      $$('img[data-src]', d).forEach(loadImg);
      $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var panel = $('.drawer__panel', d) || d;
      setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 80);
    },
    close: function (silent) {
      var d = this.current;
      if (!d) { return; }
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      unlock();
      $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      this.current = null;
      if (!silent && this.opener && this.opener.focus) { try { this.opener.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
  };

  doc.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); Drawer.open(opener.getAttribute('data-drawer-open'), opener); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); Drawer.close(); return; }
    var cartLink = t.closest('[data-cart-open]');
    if (cartLink && T.cartType === 'drawer' && doc.getElementById('CartDrawer') && !doc.querySelector('[data-cart-page]')) {
      e.preventDefault();
      Drawer.open('CartDrawer', cartLink);
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Lightbox.isOpen) { Lightbox.close(); return; }
      if (Filters.openEl) { Filters.close(); return; }
      if (Drawer.current) { Drawer.close(); return; }
      closeNav(true);
      closeSearch();
    }
    if (e.key === 'Tab') {
      if (Lightbox.isOpen) { trap(Lightbox.el, e); }
      else if (Drawer.current) { trap($('.drawer__panel', Drawer.current), e); }
      else if (Filters.openEl) { trap($('.filters__panel', Filters.openEl), e); }
    }
  });

  /* ------------------------------------------------------------ header */
  function initHeader() {
    var wrap = $('.section-header');
    var header = $('[data-header]');
    if (!wrap || !header) { return; }
    var menu = doc.getElementById('MenuDrawer');
    if (menu && menu.parentNode !== doc.body) { doc.body.appendChild(menu); }
    var mode = header.getAttribute('data-sticky');
    if (mode === 'none') { wrap.style.position = 'relative'; }
    var lastY = window.scrollY, ticking = false;
    function setOffset() {
      var hidden = wrap.classList.contains('is-hidden');
      var h = (mode === 'none' || hidden) ? 0 : wrap.offsetHeight;
      doc.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    function onScroll() {
      var y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > 8);
      if (mode === 'scroll-up') {
        var busy = header.querySelector('.is-open') || header.classList.contains('is-search-open') || header.contains(doc.activeElement) && doc.activeElement.matches('input');
        if (y > lastY + 6 && y > 260 && !busy) { wrap.classList.add('is-hidden'); }
        else if (y < lastY - 6 || y < 260) { wrap.classList.remove('is-hidden'); }
      }
      lastY = y;
      setOffset();
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    if ('ResizeObserver' in window) { new ResizeObserver(setOffset).observe(wrap); }
    onScroll();
  }

  /* ------------------------------------------------------------ nav / mega */
  var navItems = [];
  function setNavOpen(item, on) {
    item.classList.toggle('is-open', on);
    var t = $('[data-nav-trigger]', item);
    if (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    if (on) { $$('img[data-src]', item).forEach(loadImg); }
  }
  function closeNav(focusTrigger) {
    navItems.forEach(function (i) {
      if (i.classList.contains('is-open')) {
        setNavOpen(i, false);
        if (focusTrigger && i.contains(doc.activeElement)) { var t = $('[data-nav-trigger]', i); if (t) { t.focus(); } }
      }
    });
  }
  function initNav() {
    navItems = $$('[data-nav-item]');
    var pointer = 'mouse';
    navItems.forEach(function (item) {
      var trigger = $('[data-nav-trigger]', item);
      if (!trigger) { return; }
      var openT, closeT;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeT);
        openT = setTimeout(function () {
          navItems.forEach(function (o) { if (o !== item) { setNavOpen(o, false); } });
          setNavOpen(item, true);
        }, 80);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openT);
        closeT = setTimeout(function () { setNavOpen(item, false); }, 180);
      });
      trigger.addEventListener('pointerdown', function (e) { pointer = e.pointerType || 'mouse'; });
      trigger.addEventListener('click', function (e) {
        var isOpen = item.classList.contains('is-open');
        if (trigger.tagName === 'BUTTON' || (!isOpen && pointer !== 'mouse')) {
          e.preventDefault();
          navItems.forEach(function (o) { if (o !== item) { setNavOpen(o, false); } });
          setNavOpen(item, !isOpen);
        }
        pointer = 'keyboard';
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setNavOpen(item, true);
          var first = $('.mega a, .dropdown a', item);
          if (first) { first.focus(); }
        }
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { setNavOpen(item, false); }
      });
    });
    doc.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-item]')) { closeNav(); }
    });
  }

  /* ------------------------------------------------------------ announcement */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (box) {
      var msgs = $$('.announcement__msg', box);
      if (msgs.length < 2 || reduce) { return; }
      var i = 0, timer, iv = parseInt(box.getAttribute('data-interval'), 10) || 5000;
      function go() {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      function start() { clearInterval(timer); timer = setInterval(go, iv); }
      box.addEventListener('mouseenter', function () { clearInterval(timer); });
      box.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ------------------------------------------------------------ predictive search */
  function closeSearch() {
    var header = $('[data-header]');
    if (header && header.classList.contains('is-search-open')) {
      header.classList.remove('is-search-open');
      $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    var box = $('[data-predictive-results]');
    if (box) { box.hidden = true; }
  }
  function initPredictive() {
    var form = $('[data-predictive-search]');
    if (!form) { return; }
    var input = $('[data-search-input]', form);
    var box = $('[data-predictive-results]', form);
    var clearBtn = $('[data-search-clear]', form);
    var header = $('[data-header]');
    var ctrl = null, timer = null, active = -1, lastQ = '';

    function hide() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function highlight(title, q) {
      var out = esc(title);
      q.split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
        var re = new RegExp('(^|[\\s(/-])(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        out = out.replace(re, '$1<mark>$2</mark>');
      });
      return out;
    }
    function priceOf(p) {
      var raw = p.price;
      if (raw == null) { return ''; }
      var cents = String(raw).indexOf('.') > -1 ? Math.round(parseFloat(raw) * 100) : parseInt(raw, 10);
      return money(cents);
    }
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var prods = r.products || [], cols = r.collections || [], pages = r.pages || [];
      var h = '';
      if (!prods.length && !cols.length && !pages.length) {
        h = '<p class="predictive__empty">No matches for “' + esc(q) + '”. Try a brand name or a category.</p>';
      } else {
        if (prods.length) {
          h += '<div class="predictive__group"><p class="predictive__label">Products</p>';
          prods.forEach(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            h += '<a class="predictive__item" href="' + esc(p.url) + '" data-pi>' +
              '<span class="predictive__thumb">' + (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
              '<span>' + (T.showVendor && p.vendor ? '<span class="predictive__brand">' + esc(p.vendor) + '</span>' : '') + '<span class="predictive__title">' + highlight(p.title, q) + '</span></span>' +
              '<span class="predictive__price">' + priceOf(p) + '</span></a>';
          });
          h += '</div>';
        }
        if (cols.length || pages.length) {
          h += '<div class="predictive__group"><p class="predictive__label">Collections and pages</p>';
          cols.forEach(function (c) { h += '<a class="predictive__link" href="' + esc(c.url) + '" data-pi>' + ICON.grid + highlight(c.title, q) + '<small>Collection</small></a>'; });
          pages.forEach(function (c) { h += '<a class="predictive__link" href="' + esc(c.url) + '" data-pi>' + ICON.doc + highlight(c.title, q) + '<small>Page</small></a>'; });
          h += '</div>';
        }
      }
      h += '<a class="predictive__all" href="' + (T.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last" data-pi><span>See all results for “' + esc(q) + '”</span>' + ICON.arrow + '</a>';
      box.innerHTML = h;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    function query(q) {
      if (ctrl) { ctrl.abort(); }
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      box.hidden = false;
      box.innerHTML = '<p class="predictive__loading">Searching…</p>';
      var url = (T.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) { if (input.value.trim() === q) { render(q, d); } })
        .catch(function (err) { if (!err || err.name !== 'AbortError') { hide(); } });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearBtn.hidden = !input.value;
      clearTimeout(timer);
      if (q.length < 2) { lastQ = ''; hide(); return; }
      timer = setTimeout(function () { if (q !== lastQ || box.hidden) { lastQ = q; query(q); } }, 200);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && box.innerHTML) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    });
    input.addEventListener('keydown', function (e) {
      var items = $$('[data-pi]', box);
      if (box.hidden || !items.length) { return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        items[active].click();
      }
    });
    clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; hide(); input.focus(); });
    doc.addEventListener('click', function (e) {
      if (!form.contains(e.target) && !e.target.closest('[data-search-toggle]')) { hide(); }
    });
    $$('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = !header.classList.contains('is-search-open');
        header.classList.toggle('is-search-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { setTimeout(function () { input.focus(); }, 60); } else { hide(); }
      });
    });
    if (input.value) { clearBtn.hidden = false; }
  }

  /* ------------------------------------------------------------ cart */
  function sectionIds() {
    var ids = [];
    if (doc.getElementById('CartDrawer')) { ids.push('cart-drawer'); }
    var page = $('[data-cart-page]');
    if (page && page.getAttribute('data-section-id')) { ids.push(page.getAttribute('data-section-id')); }
    return ids;
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
    $$('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function setTotal(txt) {
    if (txt == null) { return; }
    $$('[data-cart-total]').forEach(function (el) { el.textContent = txt; });
  }
  function applySections(sections) {
    if (!sections) { return; }
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('[data-cart-drawer-inner]');
      var cur = $('[data-cart-drawer-inner]');
      if (fresh && cur) {
        var hadFocus = cur.contains(doc.activeElement);
        cur.replaceWith(fresh);
        setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        setTotal(fresh.getAttribute('data-total'));
        if (hadFocus) { var p = $('#CartDrawer .drawer__panel'); if (p) { p.focus({ preventScroll: true }); } }
      }
    }
    var page = $('[data-cart-page]');
    if (page) {
      var id = page.getAttribute('data-section-id');
      if (id && sections[id]) {
        var freshPage = parser.parseFromString(sections[id], 'text/html').querySelector('[data-cart-page-inner]');
        var curPage = $('[data-cart-page-inner]');
        if (freshPage && curPage) { curPage.replaceWith(freshPage); }
      }
    }
  }
  function trackAdd(unused, price, qty) {
    if (typeof window.gtag !== 'function') { return; }
    price = parseFloat(price) || 0;
    window.gtag('event', 'add_to_cart', { send_to: 'GLA', value: price * qty, currency: 'USD' });
  }
  function afterAdd() {
    if (T.cartType === 'page') { window.location.href = T.routes.cart || '/cart'; return; }
    Drawer.open('CartDrawer');
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) { throw new Error(d.description || d.message || 'Something went wrong. Please try again.'); }
        return d;
      });
    });
  }
  function addVariant(id, qty) {
    return postJSON((T.routes.cartAdd || '/cart/add') + '.js', {
      items: [{ id: parseInt(id, 10), quantity: qty || 1 }],
      sections: sectionIds().join(','),
      sections_url: window.location.pathname
    }).then(function (d) { applySections(d.sections); return d; });
  }
  function addItems(items) {
    return postJSON((T.routes.cartAdd || '/cart/add') + '.js', {
      items: items,
      sections: sectionIds().join(','),
      sections_url: window.location.pathname
    }).then(function (d) { applySections(d.sections); return d; });
  }
  // Small API for assets/assistant.js
  window.JL = { addItems: addItems, openCart: afterAdd, toast: toast };

  /* /cart?ef_cart=VARIANT:QTY,VARIANT:QTY (links from the assistant) fills the cart, then shows it */
  function initCartLink() {
    var m = /[?&]ef_cart=([0-9:,]+)/.exec(window.location.search);
    if (!m) { return; }
    var items = m[1].split(',').map(function (part) {
      var a = part.split(':');
      return { id: parseInt(a[0], 10), quantity: Math.max(1, Math.min(10, parseInt(a[1], 10) || 1)) };
    }).filter(function (i) { return i.id > 0; }).slice(0, 10);
    var rest = window.location.search.replace(/([?&])ef_cart=[0-9:,]+&?/, '$1').replace(/[?&]$/, '');
    try { history.replaceState(null, '', window.location.pathname + rest + window.location.hash); } catch (e) { /* ignore */ }
    if (!items.length) { return; }
    addItems(items)
      .then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        afterAdd();
      })
      .catch(function (err) { toast(esc(err.message), 'error'); });
  }

  /* Footer link columns: accordions on phones, always open from 750px */
  function initFooterAcc() {
    var cols = $$('[data-footer-acc]');
    if (!cols.length || !window.matchMedia) { return; }
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() { cols.forEach(function (d) { if (mq.matches) { d.setAttribute('open', ''); } else { d.removeAttribute('open'); } }); }
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); } else if (mq.addListener) { mq.addListener(sync); }
    cols.forEach(function (d) {
      var s = $('summary', d);
      if (s) { s.addEventListener('click', function (e) { if (mq.matches) { e.preventDefault(); } }); }
    });
  }

  /* Mobile bottom navigation: Search focuses the header search box */
  function initBottomNav() {
    var nav = $('[data-bottom-nav]');
    if (!nav) { return; }
    nav.addEventListener('click', function (e) {
      var s = e.target.closest('[data-bottom-search]');
      if (!s) { return; }
      var input = doc.getElementById('HeaderSearch');
      if (!input || !input.offsetParent) { return; }
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (ex) { input.focus(); } }, reduce ? 0 : 280);
    });
  }

  // Quick add from product cards
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) { return; }
    e.preventDefault();
    if (btn.classList.contains('is-loading')) { return; }
    btn.classList.add('is-loading');
    addVariant(btn.getAttribute('data-quick-add'), 1)
      .then(function () {
        trackAdd(btn.getAttribute('data-wp-id'), btn.getAttribute('data-price'), 1);
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        afterAdd();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        toast(esc(err.message), 'error');
      });
  });

  // Product form
  function initProductForms() {
    $$('form[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) { return; }
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) { return; }
        e.preventDefault();
        var btn = $('[data-add-button]', form);
        var err = $('[data-form-error]', form);
        if (!btn || btn.disabled) { return; }
        if (err) { err.hidden = true; }
        btn.classList.add('is-loading');
        var sticky = $('[data-sticky-add]');
        if (sticky) { sticky.classList.add('is-loading'); }
        var fd = new FormData(form);
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        fd.append('sections', sectionIds().join(','));
        fd.append('sections_url', window.location.pathname);
        fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok || res.d.status) { throw new Error(res.d.description || res.d.message || 'This item could not be added to your cart.'); }
            applySections(res.d.sections);
            trackAdd(btn.getAttribute('data-wp-id'), btn.getAttribute('data-price'), qty);
            afterAdd();
          })
          .catch(function (ex) {
            if (err) { err.textContent = ex.message; err.hidden = false; } else { toast(esc(ex.message), 'error'); }
          })
          .then(function () {
            btn.classList.remove('is-loading');
            if (sticky) { sticky.classList.remove('is-loading'); }
          });
      });
    });
  }

  // Quantity steppers and line updates
  var lineTimers = {};
  function changeLine(line, qty) {
    var inner = $('[data-cart-drawer-inner]'), pageInner = $('[data-cart-page-inner]');
    if (inner) { inner.classList.add('is-updating'); }
    if (pageInner) { pageInner.classList.add('is-updating'); }
    return postJSON((T.routes.cartChange || '/cart/change') + '.js', {
      line: parseInt(line, 10),
      quantity: qty,
      sections: sectionIds().join(','),
      sections_url: window.location.pathname
    }).then(function (d) {
      applySections(d.sections);
      setCount(d.item_count);
    }).catch(function (ex) {
      toast(esc(ex.message), 'error');
      var a = $('[data-cart-drawer-inner]'), b = $('[data-cart-page-inner]');
      if (a) { a.classList.remove('is-updating'); }
      if (b) { b.classList.remove('is-updating'); }
    });
  }
  doc.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = wrap && $('input', wrap);
      if (!input) { return; }
      var min = parseInt(input.min, 10); if (isNaN(min)) { min = 0; }
      var max = parseInt(input.max, 10) || 999;
      var v = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10)));
      input.value = v;
      var line = input.getAttribute('data-line-qty');
      if (line) {
        clearTimeout(lineTimers[line]);
        lineTimers[line] = setTimeout(function () { changeLine(line, parseInt(input.value, 10) || 0); }, 380);
      }
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm && window.fetch) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-line-remove'), 0);
    }
  });
  doc.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches && input.matches('[data-line-qty]')) {
      var line = input.getAttribute('data-line-qty');
      clearTimeout(lineTimers[line]);
      changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
    }
  });

  /* ------------------------------------------------------------ card hover image */
  doc.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch' || !e.target.closest) { return; }
    var card = e.target.closest('[data-alt-src]');
    if (!card || card.dataset.altLoaded) { return; }
    card.dataset.altLoaded = '1';
    var media = $('.card__media', card);
    var main = $('.card__img', card);
    if (!media || !main) { return; }
    var img = new Image();
    img.className = 'card__img card__img--alt';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    img.onload = function () { main.insertAdjacentElement('afterend', img); requestAnimationFrame(function () { card.classList.add('has-alt'); }); };
    img.src = card.getAttribute('data-alt-src');
  });

  /* ------------------------------------------------------------ slideshow */
  function initSlideshows(root) {
    $$('[data-slideshow]', root).forEach(function (el) {
      if (el.dataset.bound) { return; }
      el.dataset.bound = '1';
      var slides = $$('[data-slide]', el), dots = $$('[data-slide-dot]', el);
      if (slides.length < 2) { return; }
      var iv = parseInt(el.getAttribute('data-interval'), 10) || 7000;
      var auto = el.getAttribute('data-autoplay') === 'true' && !reduce;
      el.style.setProperty('--hero-interval', iv + 'ms');
      var i = 0, timer = null, paused = false;
      function restartDot() {
        var d = dots[i];
        if (!d) { return; }
        d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active');
      }
      function go(n) {
        var prev = i;
        i = (n + slides.length) % slides.length;
        if (prev === i) { return; }
        slides[prev].classList.remove('is-active');
        slides[prev].setAttribute('aria-hidden', 'true');
        $$('a', slides[prev]).forEach(function (a) { a.tabIndex = -1; });
        slides[i].classList.add('is-active');
        slides[i].removeAttribute('aria-hidden');
        $$('a', slides[i]).forEach(function (a) { a.removeAttribute('tabindex'); });
        dots.forEach(function (d, j) {
          d.classList.remove('is-active');
          if (j === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
        restartDot();
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (auto && !paused && !doc.hidden) { timer = setTimeout(function () { go(i + 1); }, iv); }
      }
      var prevBtn = $('[data-slide-prev]', el), nextBtn = $('[data-slide-next]', el);
      if (prevBtn) { prevBtn.addEventListener('click', function () { go(i - 1); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { go(i + 1); }); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      function pause() { paused = true; el.classList.add('is-paused'); clearTimeout(timer); }
      function resume() { paused = false; el.classList.remove('is-paused'); restartDot(); schedule(); }
      el.addEventListener('mouseenter', pause);
      el.addEventListener('mouseleave', resume);
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { resume(); } });
      var x0 = null, y0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { go(i + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
      doc.addEventListener('visibilitychange', function () { if (doc.hidden) { clearTimeout(timer); } else { schedule(); } });
      el._goTo = go;
      schedule();
    });
  }

  /* ------------------------------------------------------------ tabs */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      if (wrap.dataset.bound) { return; }
      wrap.dataset.bound = '1';
      var tabs = $$('[data-tab]', wrap), panels = $$('[data-tab-panel]', wrap);
      function select(i, focus) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        if (focus) { tabs[i].focus(); }
        var list = tabs[i].parentElement;
        if (list.scrollWidth > list.clientWidth) { list.scrollTo({ left: tabs[i].offsetLeft - 16, behavior: 'smooth' }); }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
    });
  }

  /* ------------------------------------------------------------ carousels */
  function initCarousels(root) {
    $$('[data-carousel-scope]', root).forEach(function (scope) {
      var track = $('[data-carousel]', scope);
      if (!track || track.dataset.bound) { return; }
      track.dataset.bound = '1';
      var prev = $('[data-carousel-prev]', scope), next = $('[data-carousel-next]', scope);
      function stepSize() {
        var item = track.firstElementChild;
        if (!item) { return track.clientWidth; }
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var w = item.getBoundingClientRect().width + gap;
        return w * Math.max(1, Math.floor((track.clientWidth + gap) / w));
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) { prev.disabled = track.scrollLeft <= 2; }
        if (next) { next.disabled = track.scrollLeft >= max; }
        var hideNav = max <= 0;
        [prev, next].forEach(function (b) { if (b) { b.style.visibility = hideNav ? 'hidden' : ''; } });
      }
      if (prev) { prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: reduce ? 'auto' : 'smooth' }); }); }
      if (next) { next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: reduce ? 'auto' : 'smooth' }); }); }
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ------------------------------------------------------------ accordions (animated <details>) */
  function animateDetails(d) {
    if (d.dataset.accBound) { return; }
    d.dataset.accBound = '1';
    var summary = d.querySelector('summary');
    var content = summary && summary.nextElementSibling;
    if (!summary || !content) { return; }
    summary.addEventListener('click', function (e) {
      if (reduce) { return; }
      e.preventDefault();
      if (d.dataset.animating) { return; }
      d.dataset.animating = '1';
      var done = function () { content.style.cssText = ''; delete d.dataset.animating; };
      if (d.open) {
        content.style.height = content.offsetHeight + 'px';
        content.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          content.style.transition = 'height .32s cubic-bezier(.2,.7,.2,1), opacity .25s';
          content.style.height = '0px';
          content.style.opacity = '0';
        });
        setTimeout(function () { d.open = false; done(); }, 340);
      } else {
        d.open = true;
        var h = content.offsetHeight;
        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.opacity = '0';
        requestAnimationFrame(function () {
          content.style.transition = 'height .34s cubic-bezier(.2,.7,.2,1), opacity .3s';
          content.style.height = h + 'px';
          content.style.opacity = '1';
        });
        setTimeout(done, 360);
      }
    });
  }
  function initAccordions(root) {
    $$('details[data-accordion], .rte details, .filter-group, .menu-drawer__group', root).forEach(animateDetails);
  }

  /* ------------------------------------------------------------ lightbox */
  var Lightbox = {
    el: null, isOpen: false, opener: null,
    build: function () {
      var el = doc.createElement('div');
      el.className = 'lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Product images');
      el.innerHTML = '<div class="lightbox__bar"><span class="lightbox__count" data-lb-count></span>' +
        '<button type="button" class="round-btn" data-lb-close aria-label="Close">' + ICON.close + '</button></div>' +
        '<div class="lightbox__track" data-lb-track></div>' +
        '<button type="button" class="round-btn round-btn--glass lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="Previous image">' + ICON.left + '</button>' +
        '<button type="button" class="round-btn round-btn--glass lightbox__nav lightbox__nav--next" data-lb-next aria-label="Next image">' + ICON.right + '</button>';
      doc.body.appendChild(el);
      this.el = el;
      this.track = $('[data-lb-track]', el);
      var self = this;
      $('[data-lb-close]', el).addEventListener('click', function () { self.close(); });
      $('[data-lb-prev]', el).addEventListener('click', function () { self.go(self.i - 1); });
      $('[data-lb-next]', el).addEventListener('click', function () { self.go(self.i + 1); });
      this.track.addEventListener('scroll', function () {
        requestAnimationFrame(function () {
          var n = Math.round(self.track.scrollLeft / self.track.clientWidth);
          if (n !== self.i) { self.setIndex(n); }
        });
      }, { passive: true });
      this.track.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (!img) { return; }
        var slide = img.parentElement;
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        slide.classList.toggle('is-zoomed');
      });
      this.track.addEventListener('mousemove', function (e) {
        var slide = e.target.closest('.lightbox__slide.is-zoomed');
        if (!slide) { return; }
        var img = $('img', slide), r = slide.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      doc.addEventListener('keydown', function (e) {
        if (!self.isOpen) { return; }
        if (e.key === 'ArrowRight') { self.go(self.i + 1); }
        if (e.key === 'ArrowLeft') { self.go(self.i - 1); }
      });
    },
    open: function (images, index) {
      if (!this.el) { this.build(); }
      this.images = images;
      this.opener = doc.activeElement;
      this.track.innerHTML = images.map(function (im) {
        return '<div class="lightbox__slide"><img src="' + esc(im.src) + '" alt="' + esc(im.alt) + '" decoding="async"></div>';
      }).join('');
      var multi = images.length > 1;
      $('[data-lb-prev]', this.el).hidden = !multi;
      $('[data-lb-next]', this.el).hidden = !multi;
      this.el.classList.add('is-open');
      this.isOpen = true;
      lock();
      var self = this;
      requestAnimationFrame(function () {
        self.track.scrollTo({ left: index * self.track.clientWidth, behavior: 'auto' });
        self.setIndex(index);
        $('[data-lb-close]', self.el).focus();
      });
    },
    setIndex: function (n) {
      this.i = n;
      $('[data-lb-count]', this.el).textContent = (n + 1) + ' / ' + this.images.length;
      $$('.lightbox__slide.is-zoomed', this.el).forEach(function (s, j) { if (j !== n) { s.classList.remove('is-zoomed'); } });
    },
    go: function (n) {
      var len = this.images.length;
      n = (n + len) % len;
      this.track.scrollTo({ left: n * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      this.setIndex(n);
    },
    close: function () {
      if (!this.isOpen) { return; }
      this.el.classList.remove('is-open');
      this.isOpen = false;
      unlock();
      if (this.opener && this.opener.focus) { this.opener.focus({ preventScroll: true }); }
    }
  };

  /* ------------------------------------------------------------ product page */
  function initGallery(root) {
    var g = $('[data-gallery]', root);
    if (!g || g.dataset.bound) { return; }
    g.dataset.bound = '1';
    var track = $('[data-gallery-track]', g);
    var slides = $$('[data-gallery-slide]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    var counter = $('[data-gallery-counter]', g);
    var idx = 0;
    function stopVideos(except) {
      slides.forEach(function (s, j) {
        if (j === except) { return; }
        var fr = $('iframe[data-player]', s);
        if (fr && s._poster) { fr.replaceWith(s._poster); s._poster = null; }
      });
    }
    function setActive(i) {
      if (i !== idx) { stopVideos(i); }
      idx = i;
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        if (j === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      if (counter) { counter.textContent = (i + 1) + ' / ' + slides.length; }
      var bar = thumbs[i] && thumbs[i].parentElement;
      if (bar && bar.scrollWidth > bar.clientWidth) { bar.scrollTo({ left: thumbs[i].offsetLeft - bar.clientWidth / 2 + thumbs[i].offsetWidth / 2, behavior: 'smooth' }); }
    }
    function goTo(i) {
      if (!slides.length) { return; }
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    }
    g._goTo = goTo;
    $$('.gallery__play', g).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = btn.closest('[data-gallery-slide]');
        var fr = doc.createElement('iframe');
        fr.src = btn.getAttribute('data-video-embed');
        fr.title = btn.getAttribute('data-video-title') || 'Product video';
        fr.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen');
        fr.setAttribute('allowfullscreen', '');
        fr.setAttribute('data-player', '');
        fr.className = 'gallery__iframe';
        slide._poster = btn;
        btn.replaceWith(fr);
      });
    });
    $$('[data-gallery-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(b.getAttribute('data-gallery-goto'), 10) || 0;
        var top = g.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(doc.documentElement).getPropertyValue('--header-offset'), 10) || 0) - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        goTo(n);
      });
    });
    track.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx && slides[i]) { setActive(i); }
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var p = $('[data-gallery-prev]', g), n = $('[data-gallery-next]', g);
    if (p) { p.addEventListener('click', function () { goTo(idx - 1); }); }
    if (n) { n.addEventListener('click', function () { goTo(idx + 1); }); }
    $$('[data-zoom]', g).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var images = $$('.gallery__zoom img', g).map(function (im) {
          return { src: im.getAttribute('data-full') || im.currentSrc || im.src, alt: im.alt };
        });
        Lightbox.open(images, parseInt(btn.getAttribute('data-zoom'), 10) || 0);
      });
    });
  }

  function initVariantPicker(root) {
    var wrap = $('[data-options]', root);
    // Single-variant products render no option inputs, so the matcher never runs for them.
    if (!wrap || !$('[data-option-value]', wrap) || wrap.dataset.bound) { return; }
    wrap.dataset.bound = '1';
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', wrap).textContent); } catch (e) { return; }
    var form = $('form[data-product-form]', root);
    var idInput = form && $('[data-variant-id]', form);
    var btn = form && $('[data-add-button]', form);
    var label = form && $('[data-add-label]', form);
    wrap.addEventListener('change', function () {
      var chosen = $$('.option', wrap).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      $$('[data-option-label]', wrap).forEach(function (l, i) { l.textContent = chosen[i] || ''; });
      var v = null;
      for (var k = 0; k < variants.length; k++) {
        var ok = variants[k].options.every(function (o, i) { return o === chosen[i]; });
        if (ok) { v = variants[k]; break; }
      }
      var stock = $('[data-stock]', root), stockText = $('[data-stock-text]', root);
      if (!v) {
        if (btn) { btn.disabled = true; }
        if (label) { label.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) { idInput.value = v.id; }
      if (btn) { btn.disabled = !v.available; btn.setAttribute('data-price', v.price / 100); }
      if (label) { label.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      $$('.product__price [data-price-current]').forEach(function (el) { el.innerHTML = priceHTML(v.price); });
      $$('.sticky-atc [data-price-current]').forEach(function (el) { el.textContent = money(v.price); });
      $$('.product__price [data-price]').forEach(function (box) {
        var sale = T.showCompareAt !== false && v.compare_at_price && v.compare_at_price > v.price;
        box.classList.toggle('price--sale', !!sale);
        var now = $('[data-price-now]', box), was = $('[data-price-was]', box);
        if (now) { now.hidden = !sale; }
        if (was) { was.hidden = !sale; was.innerHTML = sale ? '<span class="visually-hidden">Regular price </span>' + esc(money(v.compare_at_price)) : ''; }
      });
      if (stock) { stock.classList.toggle('is-out', !v.available); }
      if (stockText) { stockText.textContent = v.available ? stockText.getAttribute('data-in') || 'In stock' : 'Out of stock'; }
      var sticky = $('[data-sticky-add]');
      if (sticky) { sticky.disabled = !v.available; }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) { /* ignore */ }
      if (v.featured_media) {
        var g = $('[data-gallery]', root);
        var slide = g && $$('[data-gallery-slide]', g).findIndex(function (s) { return $('img', s) && $('img', s).src.indexOf(String(v.featured_media.preview_image && v.featured_media.preview_image.src || '').split('?')[0].split('/').pop()) > -1; });
        if (g && g._goTo && slide > -1) { g._goTo(slide); }
      }
    });
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) { added++; }
    }
    return d;
  }
  function initEta(root) {
    var el = $('[data-eta-range]', root);
    if (!el || !T.eta) { return; }
    try {
      var now = new Date();
      var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      el.textContent = fmt.format(addBusinessDays(now, T.eta.min)) + ' – ' + fmt.format(addBusinessDays(now, T.eta.max));
    } catch (e) { /* keep the server text */ }
  }

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var btn = $('[data-add-button]');
    var form = $('form[data-product-form]');
    if (!bar || !btn || !form) { return; }
    var add = $('[data-sticky-add]', bar);
    var shown = false, ticking = false;
    // A scroll check rather than an IntersectionObserver: a jump straight from
    // below the button to above it (Home key, anchor links) never crosses the
    // viewport, so an observer would leave the bar in the wrong state.
    function check() {
      ticking = false;
      var r = btn.getBoundingClientRect();
      var show = r.bottom < 0;
      if (show === shown) { return; }
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      doc.body.classList.toggle('has-sticky-atc', show);
      if (add) { add.tabIndex = show ? 0 : -1; }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
    if (add) {
      add.addEventListener('click', function () {
        if (form.requestSubmit) { form.requestSubmit(); } else { btn.click(); }
      });
    }
  }

  function initCopyLinks() {
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy-link]');
      if (!b) { return; }
      var url = b.getAttribute('data-copy-link');
      var ok = function () { toast('Link copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(ok, function () { window.prompt('Copy this link', url); }); }
      else { window.prompt('Copy this link', url); }
    });
  }

  /* ------------------------------------------------------------ recently viewed */
  var RV_KEY = 'jl:recent';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  function initRecent() {
    $$('[data-recently-viewed]').forEach(function (sec) {
      var ex = sec.getAttribute('data-exclude');
      var list = readRecent().filter(function (x) { return x && x.handle && x.handle !== ex; }).slice(0, 12);
      if (!list.length) { return; }
      $('[data-recent-list]', sec).innerHTML = list.map(function (p) {
        return '<li class="carousel__item"><article class="card"><div class="card__media">' +
          (p.image ? '<img class="card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="540" height="540" loading="lazy">' : '') +
          '</div><div class="card__body">' +
          '<div class="card__price"><span class="price"><span class="price__current">' + esc(p.price) + '</span></span></div>' +
          '<h3 class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3></div></article></li>';
      }).join('');
      sec.hidden = false;
      initCarousels(sec.parentElement || doc);
      var clear = $('[data-recent-clear]', sec);
      if (clear) { clear.addEventListener('click', function () { try { localStorage.removeItem(RV_KEY); } catch (e) { /* ignore */ } sec.hidden = true; }); }
    });
    var item = $('[data-recent-item]');
    if (item) {
      try {
        var cur = JSON.parse(item.textContent);
        var list = [cur].concat(readRecent().filter(function (x) { return x && x.handle !== cur.handle; })).slice(0, 13);
        localStorage.setItem(RV_KEY, JSON.stringify(list));
      } catch (e) { /* storage unavailable */ }
    }
  }


  /* ------------------------------------------------------------ search category scope */
  function initSearchScope() {
    $$('[data-predictive-search]').forEach(function (form) {
      var sel = $('[data-search-cat]', form), input = $('[data-search-input]', form);
      if (!sel || !input) { return; }
      form.addEventListener('submit', function (e) {
        var type = sel.value, q = input.value.trim();
        if (!type) { return; }
        var opt = sel.options[sel.selectedIndex];
        if (!q && opt && opt.getAttribute('data-url')) { e.preventDefault(); window.location.href = opt.getAttribute('data-url'); return; }
        if (q.indexOf('product_type:') === -1) { input.value = q + ' product_type:"' + type.replace(/"/g, '') + '"'; }
      });
    });
  }

  /* ------------------------------------------------------------ storefront filters (section rendering) */
  var Filters = {
    openEl: null,
    open: function (el) {
      this.openEl = el; el.classList.add('is-open'); lock();
      var p = $('.filters__panel', el);
      setTimeout(function () { if (p) { p.setAttribute('tabindex', '-1'); p.focus({ preventScroll: true }); } }, 60);
    },
    close: function () {
      if (!this.openEl) { return; }
      this.openEl.classList.remove('is-open'); this.openEl = null; unlock();
    }
  };

  function resultsRoot() { return $('[data-results]'); }
  function urlFromForm(form) {
    var fd = new FormData(form), params = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') { params.append(k, v); } });
    var base = form.getAttribute('action');
    var s = params.toString();
    return base + (s ? (base.indexOf('?') > -1 ? '&' : '?') + s : '');
  }
  var facetCtrl = null;
  function loadResults(url, push) {
    var root = resultsRoot();
    if (!root) { window.location.href = url; return; }
    var id = root.getAttribute('data-section-id');
    var inner = $('[data-results-inner]', root);
    var wasOpen = !!(Filters.openEl);
    if (inner) { inner.classList.add('is-loading'); }
    if (facetCtrl) { facetCtrl.abort(); }
    facetCtrl = ('AbortController' in window) ? new AbortController() : null;
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
    fetch(fetchUrl, facetCtrl ? { signal: facetCtrl.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc2 = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc2.querySelector('[data-results-inner]');
        var cur = $('[data-results-inner]');
        if (!fresh || !cur) { window.location.href = url; return; }
        if (wasOpen) { Filters.close(); }
        cur.replaceWith(fresh);
        if (wasOpen && window.innerWidth < 990) { var f = $('[data-filters]'); if (f) { Filters.open(f); } }
        initSection(fresh);
        bindFacets();
        if (push) { history.pushState({ facets: true }, '', url); }
        var top = fresh.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); }
      })
      .catch(function (err) { if (!err || err.name !== 'AbortError') { window.location.href = url; } });
  }
  function bindFacets() {
    var form = $('[data-facets]');
    if (!form || form.dataset.bound) { return; }
    form.dataset.bound = '1';
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) { return; }
      loadResults(urlFromForm(form), true);
    });
    form.addEventListener('input', function (e) {
      if (!e.target.matches('input[type="number"]')) { return; }
      clearTimeout(timer);
      timer = setTimeout(function () { loadResults(urlFromForm(form), true); }, 700);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); loadResults(urlFromForm(form), true); });
    $$('[data-price-band]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var parts = b.getAttribute('data-price-band').split('-');
        var min = form.querySelector('[name="' + b.getAttribute('data-min-name') + '"]');
        var max = form.querySelector('[name="' + b.getAttribute('data-max-name') + '"]');
        if (min) { min.value = parts[0] === '0' ? '' : parts[0]; }
        if (max) { max.value = parts[1] === '100000' ? '' : parts[1]; }
        loadResults(urlFromForm(form), true);
      });
    });
    var proxy = $('[data-sort-proxy]');
    var sort = $('[data-sort]', form);
    if (proxy && sort && !proxy.dataset.bound) {
      proxy.dataset.bound = '1';
      proxy.addEventListener('change', function () { sort.value = proxy.value; loadResults(urlFromForm(form), true); });
    }
  }
  doc.addEventListener('click', function (e) {
    var open = e.target.closest('[data-filters-open]');
    if (open) { e.preventDefault(); var f = $('[data-filters]'); if (f) { Filters.open(f); } return; }
    if (e.target.closest('[data-filters-close]')) { e.preventDefault(); Filters.close(); return; }
    var link = e.target.closest('[data-filter-link], [data-results] .pagination a, [data-filters-clear]');
    if (link && resultsRoot() && link.href) { e.preventDefault(); Filters.close(); loadResults(link.href, true); }
  });
  window.addEventListener('popstate', function () { if (resultsRoot()) { loadResults(window.location.href, false); } });

  /* ------------------------------------------------------------ back to top */
  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn) { return; }
    var ring = $('circle', btn), shown = false, ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || doc.documentElement.scrollTop;
      var max = doc.documentElement.scrollHeight - window.innerHeight;
      var show = y > Math.max(600, window.innerHeight * 1.1);
      if (show !== shown) { shown = show; btn.classList.toggle('is-visible', show); btn.tabIndex = show ? 0 : -1; }
      if (ring) { ring.style.strokeDashoffset = (100 - (max > 0 ? Math.min(1, y / max) : 0) * 100).toFixed(2); }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var main = doc.getElementById('MainContent');
      if (main && btn === doc.activeElement) { setTimeout(function () { try { main.focus({ preventScroll: true }); } catch (e) { main.focus(); } }, reduce ? 0 : 600); }
    });
    update();
  }

  /* ------------------------------------------------------------ document contents (TOC) */
  function initToc() {
    var toc = $('[data-toc]'), src = $('[data-toc-source]');
    if (!toc || !src) { return; }
    var heads = $$('h2', src).filter(function (h) { return h.textContent.trim(); });
    if (heads.length < 3) { return; }
    var list = $('[data-toc-list]', toc), used = {};
    list.innerHTML = heads.map(function (h) {
      var base = h.id || h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
      var id = base, n = 2;
      while (used[id] || (doc.getElementById(id) && doc.getElementById(id) !== h)) { id = base + '-' + n++; }
      used[id] = true; h.id = id;
      return '<li><a href="#' + id + '">' + esc(h.textContent.trim()) + '</a></li>';
    }).join('');
    toc.hidden = false;
    var links = $$('a', list), ticking = false, last = null;
    function spy() {
      ticking = false;
      var line = Math.min(window.innerHeight * 0.4, 260), current = heads[0].id;
      for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top <= line) { current = heads[i].id; } else { break; } }
      if (current === last) { return; }
      last = current;
      links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
  }

  /* ------------------------------------------------------------ jump links: highlight the section in view */
  function initJump() {
    var links = $$('.jump__list a');
    if (!links.length || !('IntersectionObserver' in window)) { return; }
    var map = {};
    links.forEach(function (a) { var id = a.getAttribute('href').slice(1); var el = doc.getElementById(id); if (el) { map[id] = a; } });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && map[en.target.id]) {
          links.forEach(function (a) { a.classList.remove('is-active'); });
          map[en.target.id].classList.add('is-active');
        }
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(doc.getElementById(id)); });
  }

  /* ------------------------------------------------------------ reveal on scroll */
  function initReveal() {
    if (!doc.body.classList.contains('has-reveal') || reduce || !('IntersectionObserver' in window)) { return; }
    var els = $$('[data-reveal]'), fired = false;
    var io = new IntersectionObserver(function (entries) {
      fired = true;
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.94) { return; }
      el.classList.add('is-armed');
      io.observe(el);
    });
    setTimeout(function () { if (!fired) { els.forEach(function (el) { el.classList.remove('is-armed'); }); } }, 2000);
    window.addEventListener('beforeprint', function () { els.forEach(function (el) { el.classList.add('is-revealed'); }); });
  }

  /* ------------------------------------------------------------ boot */
  function initSection(root) {
    initSlideshows(root);
    initTabs(root);
    initCarousels(root);
    initAccordions(root);
    initGallery(root);
    initVariantPicker(root);
    initEta(root);
    initProductForms();
  }
  function boot() {
    initHeader();
    initNav();
    initAnnouncement();
    initPredictive();
    initSearchScope();
    initSection(doc);
    bindFacets();
    initStickyAtc();
    initCopyLinks();
    initRecent();
    initToc();
    initJump();
    initBackToTop();
    initReveal();
    initBottomNav();
    initCartLink();
    initFooterAcc();
    var stock = $('[data-stock-text]');
    if (stock && !stock.getAttribute('data-in')) { stock.setAttribute('data-in', stock.textContent); }
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  doc.addEventListener('shopify:section:load', function (e) { initSection(e.target); bindFacets(); if (e.target.querySelector('[data-header]')) { initNav(); initPredictive(); initSearchScope(); } });
})();

/* Erafav: muted product clips play only while visible; reduced-motion visitors keep the poster frame. */
(function () {
  var vids = document.querySelectorAll('video[data-autoplay]');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var play = function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
  if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'metadata'; play(v); } else { v.pause(); }
    });
  }, { rootMargin: '120px 0px', threshold: 0.2 });
  vids.forEach(function (v) { io.observe(v); });
})();
